import { render } from "./SoftModal.vue?vue&type=template&id=a73991ee&scoped=true"
import script from "./SoftModal.vue?vue&type=script&lang=js"
export * from "./SoftModal.vue?vue&type=script&lang=js"

import "./SoftModal.vue?vue&type=style&index=0&id=a73991ee&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a73991ee"]])

export default __exports__